var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaskGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_141_305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00391,
    y: 0.731689,
    width: 118.694,
    height: 118.694,
    fill: "#0496FF",
    stroke: "#0496FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_141_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-62.6689 50.3564L48.8908 183.308",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.4434 40.0981L61.1164 173.05",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.2188 29.8398L73.341 162.792",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.9932 19.5815L85.5666 152.533",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.7666 9.32275L97.7931 142.274",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.54102 -0.935547L110.019 132.016",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6836 -11.1938L122.243 121.758",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9092 -21.4521L134.469 111.5",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1348 -31.7104L146.694 101.241",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3594 -41.9688L158.919 90.983",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.585 -52.2271L171.145 80.7247",
    stroke: "#0496FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8115 -62.4858L183.371 70.4659",
    stroke: "#0496FF",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskGroup);
export default __webpack_public_path__ + "static/media/MaskGroup.27bc81676bfb4e565ebbc50ffceb9123.svg";
export { ForwardRef as ReactComponent };